<template>
  <div>
    <el-table :data="projects">
      <el-table-column label="时间">
        <template slot-scope="scope">
          {{
          scope.row.createTime | moment
          }}
        </template>
      </el-table-column>
      <el-table-column prop="mortgageCoinType" label="抵押币种"></el-table-column>
      <el-table-column label="借贷币种">
        <template slot-scope="scope">
          {{
          scope.row.borrowCoinType
          }}
        </template>
      </el-table-column>
      <el-table-column prop="borrowingMortgageScale" label="借贷比例"></el-table-column>
      <el-table-column prop="burstScale" label="爆仓比例"></el-table-column>
      <el-table-column label="警告比例" prop="warnScale"></el-table-column>
      <el-table-column label="借币精度" prop="borrowPrecision"></el-table-column>
      <el-table-column label="抵押精度" prop="mortgagePrecision"></el-table-column>
      <el-table-column prop="minMortgageAmount" label="最小抵押数量"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-tooltip content="修改">
            <el-button
              type="primary"
              size="small"
              circle
              icon="el-icon-edit"
              @click="edit(scope.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="删除">
            <el-button
              type="danger"
              size="small"
              circle
              icon="el-icon-delete"
              @click="removeList(scope.row)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <detail @refresh="handleCurrentChange()"></detail>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import Detail from "../detail";

export default {
  name: "mortgageList",
  computed: {
    ...mapState("mortgage", ["projects", "listCycleCoin", "editingProject"])
  },
  components: {
    Detail,
  },
  methods: {
    ...mapActions("mortgage", ["remove", "getList"]),
    ...mapMutations("mortgage", ["setEditingProject", "setListCycleCoin",'setViewProject']),
    edit(project) {
      this.setEditingProject(project);
    },
    viewCycle(project){
      this.setViewProject(project);
    },
    handleCurrentChange(pagination) {
      this.$emit("refresh", pagination);
    },
    removeList(row) {
      this.$confirm("确认要进行此操作吗？", "提示", { type: "warning" }).then(
        () => {
          this.remove({
            borrowCoinType: row.borrowCoinType,
            mortgageCoinType: row.mortgageCoinType
          }).then(() => {
            this.$message.success("删除成功！");
            this.getList();
          });
        }
      );
    }
  }
};
</script>

<style lang="less" scoped>
</style>
